import React, { useState } from 'react';
import { useStore } from 'effector-react';
import WidgetRow from '@components/PlayerWidgets/WidgetRow';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import ColorPicker from '@components/ColorPicker';
import { Dropdown } from '@components/Dropdown';
import { fontSizeItems } from '@components/PlayerWidgets/WidgetRowFont/WidgetRowFont';
import WidgetRowAlign from '@components/PlayerWidgets/WidgetRowAlign';
import { reAddEditingHotspot } from '@modules/hotspot/actions';
import { WidgetRowWrittingMode } from '@components/PlayerWidgets/WidgetRowWrittingMode';
import { TITLE_SETTING_DEFAULT } from '../../constants';

export function TitleTextSetting() {
  const { hotspot, isBatch } = useStore($editingHotspot)!;
  const { titleSetting } = hotspot;
  const {
    font = TITLE_SETTING_DEFAULT.font,
    writingMode = TITLE_SETTING_DEFAULT.writingMode,
    align = TITLE_SETTING_DEFAULT.align,
  } = titleSetting;
  const [fontSize, setFontSize] = useState<number | null>(
    isBatch ? null : font.fontSize
  );
  const [fontColor, setFontColor] = useState<string | undefined>(
    isBatch ? undefined : font.fontColor
  );

  return (
    <>
      <WidgetRow>
        <div className="mb-10">字号：</div>
        <Dropdown
          items={fontSizeItems}
          selected={fontSize}
          onChange={(val) => {
            setFontSize(val);
            $editingHotspotApi.update((draft) => {
              draft.titleSetting.font.fontSize = val;
            });
            if (isBatch) {
              reAddEditingHotspot();
            }
          }}
        />
        <ColorPicker
          className="mt-20"
          colorString={fontColor}
          onChange={(colorString) => {
            setFontColor(colorString);
            $editingHotspotApi.update((draft) => {
              draft.titleSetting.font.fontColor = colorString;
            });
            if (isBatch) {
              reAddEditingHotspot();
            }
          }}
        >
          <ColorPicker.Header>字体颜色：</ColorPicker.Header>
          <ColorPicker.Bar />
        </ColorPicker>
      </WidgetRow>
      <WidgetRowWrittingMode
        value={writingMode}
        onChange={(val) => {
          $editingHotspotApi.update((draft) => {
            draft.titleSetting.writingMode = val;
          });
        }}
      />
      <WidgetRowAlign
        value={align}
        vertical={writingMode === 1}
        onChange={(val) => {
          $editingHotspotApi.update((draft) => {
            draft.titleSetting.align = val;
          });
        }}
      />
    </>
  );
}
